import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MessagesSquare } from "lucide-react";
import { api, fmtDate } from "@/lib/api";
import { Card, Loader } from "@/components/Common";

export const STATUS_LABEL = { inviata: "Inviata", in_valutazione: "In valutazione", in_attesa_utente: "In attesa di tue informazioni", chiusa: "Chiusa" };
export const ASSESS_LABEL = { confermata: "Analisi AI confermata", corretta: "Analisi AI corretta", integrata: "Analisi AI integrata", non_valutabile: "Non valutabile senza ulteriori elementi" };
export const FOLLOWUP_LABEL = { altre_foto: "Altre fotografie", visita: "Visita diretta", analisi_laboratorio: "Analisi di laboratorio", analisi_terreno: "Analisi del terreno", analisi_vegetale: "Analisi vegetale" };

export default function Consultations() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/consultations").then(({ data }) => setItems(data)); }, []);
  if (!items) return <Loader />;

  return (
    <div className="space-y-5 px-5 py-6" data-testid="consultations-page">
      <div>
        <p className="eyebrow">Dott.ssa Luigia De Vanna</p>
        <h1 className="font-serif text-4xl font-semibold text-[#0D2517]">Le mie consulenze</h1>
      </div>
      {items.length === 0 && (
        <div className="rounded-2xl border border-dashed border-[#C9A96E] bg-white p-8 text-center" data-testid="consultations-empty">
          <MessagesSquare className="mx-auto text-[#C9A96E]" />
          <p className="mt-3 text-sm text-[#5b6b60]">Nessuna richiesta. Puoi richiedere una consulenza al termine di ogni analisi.</p>
        </div>
      )}
      {items.map((c) => (
        <Card key={c.id} testid={`consultation-${c.id}`}>
          <div className="flex items-center justify-between">
            <p className="text-sm font-semibold">{c.species?.common_name || "Pianta"} · {fmtDate(c.created_at)}</p>
            <span className="rounded-full bg-[#0D2517] px-2.5 py-0.5 text-[10px] font-semibold text-[#F7F4EE]" data-testid={`consultation-status-${c.id}`}>{STATUS_LABEL[c.status]}</span>
          </div>
          {c.review ? (
            <div className="mt-3 border-l-2 border-[#C9A96E] pl-3" data-testid={`consultation-review-${c.id}`}>
              <p className="eyebrow">Valutazione professionale</p>
              <p className="text-xs text-[#5b6b60]">{ASSESS_LABEL[c.review.ai_assessment]}</p>
              {c.review.professional_diagnosis && <p className="mt-1 text-sm font-semibold text-[#0D2517]">{c.review.professional_diagnosis}</p>}
              {c.review.recommendations && <p className="mt-1 whitespace-pre-line text-sm">{c.review.recommendations}</p>}
              {c.review.followup?.length > 0 && <p className="mt-2 text-xs"><strong>Richiesto:</strong> {c.review.followup.map((f) => FOLLOWUP_LABEL[f]).join(", ")}</p>}
              {c.review.outcome && <p className="mt-1 text-xs"><strong>Esito:</strong> {c.review.outcome}</p>}
            </div>
          ) : (
            <p className="mt-2 text-xs text-[#5b6b60]">In attesa della valutazione della professionista.</p>
          )}
          <Link to={`/analisi/${c.analysis_id}`} className="mt-3 inline-block text-xs text-[#0D2517] underline" data-testid={`consultation-analysis-link-${c.id}`}>Vedi analisi preliminare</Link>
        </Card>
      ))}
    </div>
  );
}
